var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Machina_open, _Machina_queue, _Machina_resolve;
/**
 * Infinite async generator. Iterates messages pushed to it until closed.
 * Only one consumer is expected to use a Machina instance at a time.
 *
 * @example
 * ```ts
 * // Create the Machina instance
 * const machina = new Machina<string>();
 *
 * // Async generator loop
 * async function getMessages() {
 *   for await (const msg of machina.stream()) {
 *     console.log(msg);
 *   }
 * }
 *
 * // Start the generator
 * getMessages();
 *
 * // Push messages to it
 * machina.push('hello!');
 * machina.push('whats up?');
 * machina.push('greetings');
 *
 * // Stop the generator
 * machina.close();
 * ```
 */
class Machina {
    constructor() {
        _Machina_open.set(this, true);
        _Machina_queue.set(this, []);
        _Machina_resolve.set(this, void 0);
    }
    /** Get messages as an AsyncGenerator. */
    async *stream() {
        __classPrivateFieldSet(this, _Machina_open, true, "f");
        while (__classPrivateFieldGet(this, _Machina_open, "f")) {
            if (__classPrivateFieldGet(this, _Machina_queue, "f").length) {
                yield __classPrivateFieldGet(this, _Machina_queue, "f").shift();
                continue;
            }
            await new Promise((_resolve) => {
                __classPrivateFieldSet(this, _Machina_resolve, _resolve, "f");
            });
        }
    }
    /** Push a message into the Machina instance, making it available to the consumer of `stream()`. */
    push(data) {
        __classPrivateFieldGet(this, _Machina_queue, "f").push(data);
        __classPrivateFieldGet(this, _Machina_resolve, "f")?.call(this);
    }
    /** Closes the Machina instance, ending the stream. Calling `stream()` again causes it to be re-opened. */
    close() {
        __classPrivateFieldSet(this, _Machina_open, false, "f");
        __classPrivateFieldGet(this, _Machina_resolve, "f")?.call(this);
    }
}
_Machina_open = new WeakMap(), _Machina_queue = new WeakMap(), _Machina_resolve = new WeakMap();
export { Machina };
